import {MimickPose} from './MimickPose';

export class MimickCamera {
    readonly pose:MimickPose;
    constructor() {
        this.pose = new MimickPose();
    }
}
